import React, { useEffect } from 'react';
import QuarterlySidebar from '@molecules/pursuitLeader/components/quarterlySidebar';
import {
  SidebarWrapper,
  SidebarTitle,
  SummaryTextWrapper,
  SidebarShowHideIcon,
} from '@atoms/sidebar/sidebar.styles';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  Recoil_Quarter_State,
  Recoil_Summary_Drawer_Toggle,
  SidebarExpandCollapseState,
  Is_Baddata_Available,
} from '@recoil/recoil';
import { isMobile, isTablet } from 'react-device-detect';
import { MotifButton, MotifIcon, MotifTooltip } from '@ey-xd/motif-react';
import {
  navigationIcClose24px,
  // hardwareIcKeyboardArrowRight24px,
  // hardwareIcKeyboardArrowLeft24px,
  actionIcInfo24px,
} from '@ey-xd/motif-react/assets/icons';

const SideBar = () => {
  const quarterInfo = useRecoilValue(Recoil_Quarter_State);
  const [summaryDrawerToggle, setSummaryDrawerToggle] = useRecoilState(
    Recoil_Summary_Drawer_Toggle,
  );
  const [sidebarExpandState, setSidebarExpandState] = useRecoilState(SidebarExpandCollapseState);
  const isBaddataFound = useRecoilValue(Is_Baddata_Available);

  useEffect(() => {
    if (localStorage.getItem('isSidebarExpanded')) {
      setSidebarExpandState(JSON.parse(localStorage.getItem('isSidebarExpanded')));
    }
  }, []);

  const onTitleClick = () => {
    setSummaryDrawerToggle(!summaryDrawerToggle);
  };

  // Uncomment below function to enable sidebar expand/collapse functionality
  const onExpandCollapseClick = () => {
    setSidebarExpandState(!sidebarExpandState);
    localStorage.setItem('isSidebarExpanded', !sidebarExpandState);
  };

  const handleKeyPress = event => {
    if (event.code === 'Enter' || event.code === 'Space') {
      onExpandCollapseClick();
    }
  };

  const addFocus = event => {
    event.target.classList.add('focusContainer');
  };

  const removeFocus = event => {
    event.target.classList.remove('focusContainer');
  };

  const screenWidth = window.innerWidth;

  return (
    <SidebarWrapper>
      <SidebarTitle>
        {quarterInfo !== null ? (
          <>
            {sidebarExpandState ? (
              <SummaryTextWrapper>
                <h3> Summary</h3>

                {isBaddataFound ? (
                  <MotifTooltip
                    id="bottom"
                    trigger={
                      <MotifIcon
                        src={actionIcInfo24px}
                        style={{
                          color: '#f95d54',
                          width: '30px',
                          height: '30px',
                          paddingLeft: '10px',
                          paddingTop: '5px',
                        }}
                      ></MotifIcon>
                    }
                    allowHover={true}
                    allowClick={true}
                    placement="bottom"
                  >
                    Summary data could be <br /> incorrect due to missing <br />
                    information in certain <br />
                    opportunities. Verify and <br />
                    update the opportunity values <br /> for accuracy.
                  </MotifTooltip>
                ) : null}
              </SummaryTextWrapper>
            ) : null}

            {/* Uncomment below condition to enable sidebar expand/collapse functionality */}
            {!isMobile ? (
              <SidebarShowHideIcon
                onKeyDown={handleKeyPress}
                onFocus={addFocus}
                onBlur={removeFocus}
              >
                <MotifButton
                  onClick={onExpandCollapseClick}
                  style={{ color: '#FFFF00', cursor: 'pointer', backgroundColor: 'transparent' }}
                >
                  {sidebarExpandState ? 'Collapse' : 'Expand'}
                </MotifButton>
              </SidebarShowHideIcon>
            ) : null}
          </>
        ) : null}
        {/*1170 bcz cross button was visible on tablet view that cross icon not needed because sidebar visible on right side */}
        {(isMobile || isTablet) && screenWidth < 1170 ? (
          <MotifIcon
            onClick={onTitleClick}
            src={navigationIcClose24px}
            style={{ color: '#FFFFFF' }}
            aria-label="Close button"
            tabIndex={0}
            onFocus={e => (e.currentTarget.style.border = '1px solid #FFFFFF')}
            onBlur={e => (e.currentTarget.style.border = 'none')}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                onTitleClick(e);
              }
            }}
          />
        ) : null}
      </SidebarTitle>
      <QuarterlySidebar />
    </SidebarWrapper>
  );
};
export default SideBar;
